module.exports = __webpack_public_path__ + "static/media/new_dir_light_icn.aff698b7.png";